import { METHOD } from './method'

export const API_CATEGORY = {
    LIST: {
        api: '/v1/dashboard-admin/category/list',
        method: METHOD.POST,
    },
    DELETE: {
        api: '/v1/dashboard-admin/category',
        method: METHOD.DELETE,
    },
    EXPORT: {
        api: '/v1/dashboard-admin/category/export',
        method: METHOD.POST,
    },
    PARENT_LIST: {
        api: '/v1/dashboard-admin/category/list',
        method: METHOD.GET,
    },
    URL_THUMBNAIL: {
        api: '/v1/dashboard-admin/category/storage-url/attachment',
        method: METHOD.POST,
    },
    CREATE: {
        api: '/v1/dashboard-admin/category',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/category',
        method: METHOD.PUT,
    },
}
